module.exports = __webpack_public_path__ + "img/trash-can-plus.685333a9.svg";